<template>
  <div ref="intersectionObserver" class="intersection-observer">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = withDefaults(
  defineProps<{
    root?: () => Element | null
  }>(),
  { root: undefined }
)

const emit = defineEmits(['onIntersection'])

const isIntersecting = ref(false)
const intersectionObserver = ref<HTMLElement | null>(null)

let observer: IntersectionObserver | null = null

const handleIntersection = (entries: IntersectionObserverEntry[]) => {
  const wasIntersecting = isIntersecting.value
  entries.forEach((element: IntersectionObserverEntry) => {
    isIntersecting.value = element.isIntersecting
  })
  if (isIntersecting.value && !wasIntersecting) {
    emit('onIntersection')
  }
}

onMounted(() => {
  const root = props.root ? props.root() : null
  observer = new IntersectionObserver(handleIntersection, { root })
  if (intersectionObserver.value) {
    observer.observe(intersectionObserver.value)
  }
})

onBeforeUnmount(() => {
  if (intersectionObserver.value) {
    observer?.unobserve(intersectionObserver.value)
  }
  observer?.disconnect()
})
</script>

<style scoped></style>
